// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 943) return "static/chunks/943-940b24992d76401b.js";
	if (chunkId === 664) return "static/chunks/664-ecbcee209eae4b08.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"0967a8b068ac7399","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"3e51a91b8af7e57e","367":"ac39c692d810230f","639":"cf9d73bb0d566e4a","748":"6f50af4bb24acb0e"}[chunkId] + ".js";
};